function b(r, n, e) {
  e === void 0 && (e = {});
  var t = u;
  if (e.forceProxy && !e.proxyURL)
    throw new Error("No proxyURL is set, but forceProxy is true");
  e.forceProxy || (c() && (t = s), navigator.msSaveBlob && (t = l)), t(r, n, e);
}
var v = function() {
  return document.createElement("a");
}, c = function() {
  return "download" in v();
};
function l(r, n) {
  var e = r;
  if (typeof r == "string") {
    for (var t = r.split(";base64,"), a = t[0], f = atob(t[1]), i = new Uint8Array(f.length), o = 0; o < f.length; o++)
      i[o] = f.charCodeAt(o);
    e = new Blob([i.buffer], { type: a });
  }
  navigator.msSaveBlob(e, n);
}
function s(r, n) {
  var e = r;
  window.Blob && r instanceof Blob && (e = URL.createObjectURL(r));
  var t = v();
  t.download = n, t.href = e;
  var a = document.createEvent("MouseEvents");
  a.initMouseEvent(
    "click",
    !0,
    !1,
    window,
    0,
    0,
    0,
    0,
    0,
    !1,
    !1,
    !1,
    !1,
    0,
    null
  ), t.dispatchEvent(a), setTimeout(function() {
    return URL.revokeObjectURL(e);
  });
}
function u(r, n, e) {
  if (e.proxyURL) {
    var t = document.createElement("form");
    t.setAttribute("action", e.proxyURL), t.setAttribute("method", "POST"), t.setAttribute("target", e.proxyTarget || "_self");
    var a = e.proxyData || {};
    a.fileName = n;
    var f = r.split(";base64,");
    a.contentType = f[0].replace("data:", ""), a.base64 = f[1];
    for (var i in a)
      if (a.hasOwnProperty(i)) {
        var o = document.createElement("input");
        o.setAttribute("type", "hidden"), o.setAttribute("name", i), o.setAttribute("value", a[i]), t.appendChild(o);
      }
    document.body.appendChild(t), t.submit(), document.body.removeChild(t);
  }
}
export {
  b as s
};
